$(document).ready(function () {
  $(document).on(
    "click",
    "#show-deactivated-booking-table-button",
    function () {
      $("#deactivated-booking-tables").removeClass("d-none");
      $(this).addClass("d-none");
    },
  );
});
